import { render, staticRenderFns } from "./SponsoredRecommendationPremiumImage.vue?vue&type=template&id=aacb1920&scoped=true"
import script from "./SponsoredRecommendationPremiumImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SponsoredRecommendationPremiumImage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SponsoredRecommendationPremiumImage.vue?vue&type=style&index=0&id=aacb1920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aacb1920",
  null
  
)

export default component.exports